import React from 'react'
import { useLanguage } from '../../contexts/LanguageContext'
import { Col, Row } from 'reactstrap'

const CommitedToCare = () => {
    const { t } = useLanguage();
  return (
    <div id='website-responsive'>
        <div className='left-padding8rem1 right-padding8rem1 pb-lg-5 pb-4'>
        <Row className=''>
            <Col lg='5' className=''>
            <div className='d-flex justify-content-center'>
                <img src='/healthcare/Health-Care-Image-1.webp' alt=' ' className='img-w5' />
            </div>
            </Col>

            <Col lg='7' className=''>
            <div className='pt-lg-0 pt-4'>
                        <div className='mb-lg-3 mb-2'>
                            <h2 className='fs-ss-34 text-philos fw-800 text-ss-black'>
                                {t('healthcare.committedToCare.title')}
                            </h2>
                        </div>

                        <div className='melg-5'>
                            <p className='fs-ss-16 text-mulish fw-500 text-ss-black lh-1-6'>
                            {t('healthcare.committedToCare.content')}
                            </p>
                        </div>
                    </div>
            </Col>
        </Row>
            

            
        </div>
    </div>
  )
}

export default CommitedToCare